import { Map, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const clinics = [{
  id: "limassol",
  city: "Limassol",
  name: "Bodywerks Limassol Clinic",
  address: "Foloune House, Gladstonos 120, Unit 5, Limassol 3032",
  phone: "+357 96 117140",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=Bodywerks%20Gladstonos%20120%20Limassol",
  bookUrl: "https://bodywerks.chiroflow.cloud/book"
}, {
  id: "nicosia",
  city: "Nicosia",
  name: "Bodywerks Nicosia Clinic",
  address: "Alexiou Building, Ifigenias 62, 3rd Floor, Nicosia 2003 (by appointment)",
  phone: "+357 99 433537",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=Ifigenias%2062%20Nicosia%202003",
  bookUrl: "https://foot-forward.com/booking/"
}];
export default function ClinicCards() {
  return <section id="clinic-cards" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {clinics.map((clinic, i) => <Card key={clinic.id} data-index={i} className="flex flex-col h-full border-border shadow-sm hover:shadow-md transition-shadow duration-300">
              <CardHeader>
                <CardTitle className="text-3xl text-primary font-serif">
                  {clinic.city}
                </CardTitle>
                <CardDescription className="text-lg font-medium text-foreground">
                  {clinic.name}
                </CardDescription>
              </CardHeader>
              <CardContent className="flex-1 space-y-5">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                  <span className="text-muted-foreground leading-relaxed">
                    {clinic.address}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-accent shrink-0" />
                  <a href={`tel:${clinic.phone.replace(/\s/g, "")}`} className="text-muted-foreground hover:underline">{clinic.phone}</a>
                </div>
              </CardContent>
              <CardFooter className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-border/50">
                <Button asChild className="w-full sm:w-auto">
                  <Link to={clinic.bookUrl}>Book Appointment</Link>
                </Button>
                <Button asChild variant="outline" className="w-full sm:w-auto">
                  <Link to={clinic.mapUrl} newTab>
                    <Map className="w-4 h-4 mr-2" />
                    View on Map
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}